import { createSlice } from '@reduxjs/toolkit';
import { Catalog, Product } from '@src/pages/Catalogs';
import { ProductCatalog } from '@src/pages/Products';

interface CatalogState {
	value: Catalog | {};
	allProducts: Product[] | [];
	allMasterCatalogProducts: Product[] | [];
	allCatalogs: Catalog[] | [];
	allMasterCatalogs: Catalog[] | [];
	allCustomers: any;
	allCategories: any;
	allAttributes: any;
	allTaxClasses: any;
	allStockStatus: any;
	productCatalog: ProductCatalog | {};
	allProductsMasterCatalog: ProductCatalog[] | [];
	pageNumber: number;
}

const initialState: CatalogState = {
	value: {},
	allProducts: [],
	allMasterCatalogProducts: [],
	allCatalogs: [],
	allMasterCatalogs: [],
	allCustomers: [],
	allCategories: [],
	allAttributes: [],
	allTaxClasses: [],
	allStockStatus: [],
	productCatalog: {},
	allProductsMasterCatalog: [],
	pageNumber: 1,
};

export const catalogSlice = createSlice({
	name: 'supplierCatalog',
	initialState,
	reducers: {
		setSupplierCatalog: (state, supplierCatalog) => {
			state.value = supplierCatalog.payload;
		},
		setAllCatalogs: (state, action) => {
			state.allCatalogs = action.payload;
		},
		setAllMasterCatalogs: (state, action) => {
			state.allMasterCatalogs = action.payload;
		},
		setAllProducts: (state, action) => {
			state.allProducts = action.payload;
		},
		setAllMasterCatalogProducts: (state, action) => {
			state.allMasterCatalogProducts = action.payload;
		},
		setAllCustomers: (state, action) => {
			state.allCustomers = action.payload;
		},
		setAllCategories: (state, action) => {
			state.allCategories = action.payload;
		},
		setAllAttributes: (state, action) => {
			state.allAttributes = action.payload;
		},
		setAllTaxClasses: (state, action) => {
			state.allTaxClasses = action.payload;
		},
		setAllStockStatus: (state, action) => {
			state.allStockStatus = action.payload;
		},
		setProductCatalog: (state, action) => {
			state.productCatalog = action.payload;
		},
		setAllProductsMasterCatalog: (state, action) => {
			state.allProductsMasterCatalog = action.payload;
		},
		setPageNumber: (state, action) => {
			state.pageNumber = action.payload;
		},
	},
});

// Action creators are generated for each case reducer function
export const {
	setSupplierCatalog,
	setAllProducts,
	setAllMasterCatalogProducts,
	setAllCatalogs,
	setAllMasterCatalogs,
	setAllCustomers,
	setAllAttributes,
	setAllCategories,
	setAllTaxClasses,
	setAllStockStatus,
	setProductCatalog,
	setAllProductsMasterCatalog,
	setPageNumber,
} = catalogSlice.actions;

export default catalogSlice.reducer;
